// IMPORT PACKAGE REFERENCES

import React, { Component } from 'react';
import { Pie as PieChart } from 'react-chartjs';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES
import { fetchPharmacies } from '../State/Actions/PharmacyActions';
import { fetchReports } from '../State/Actions/ReportActions';

// COMPONENT

var options = {
    animation: {
        animateRotate: false,
        animateScale: false,
        duration: 0,
        easing: 'linear',
    }
};

class HomePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            charts : []
        }
    }

    componentDidMount() {
        this.props.fetchPharmacies();
        this.props.fetchReports();
    }

    componentWillReceiveProps(nextProps) {
        this.calculateStatistics(nextProps.pharmacies);
    }

    calculateStatistics(pharmacies) {
        let chartNames = ['Unassigned Pharmacies']
        let charts = [];

        let unattached = 0;
        let batteryLow = 0;
        let deactivated = 0;
        let notReceivingData = 0;

        let total = Object.keys(pharmacies).length;

        pharmacies.forEach(pharmacy => {
            if (pharmacy.properties['unattachedPharmacy']) {
                unattached += 1;
            } 

            if (pharmacy.properties['batteryLow']) {
                batteryLow += 1;
            } 

            if (pharmacy.properties['deactivatedPharmacy']) {
                deactivated += 1;
            } 

            if (pharmacy.properties['notReceivingData']) {
                notReceivingData += 1;
            } 
        })


        let chart = {name : 'Unassigned Pharmacies', type: 'pie', data: [{
                    value: unattached,
                    color: "#46BFBD",
                    highlight: "#5AD3D1",
                    label: "Unassigned"
                    },
                    {
                        value: total - unattached,
                        color: "#FDB45C",
                        highlight: "#5AD3D1",
                        label: "Assigned"
                    }
        ]}

        charts.push(chart);

        chart = {name : 'Battery Low (less than 25%)', type: 'pie', data: [{
            value: batteryLow,
            color: "#46BFBD",
            highlight: "#5AD3D1",
            label: "Low"
            },
            {
                value: total - batteryLow,
                color: "#FDB45C",
                highlight: "#5AD3D1",
                label: "Not Low"
            }
        ]}
        charts.push(chart);

        chart = {name : 'Active Pharmacies', type: 'pie', data: [{
            value: total - deactivated,
            color: "#FDB45C",
            highlight: "#5AD3D1",
            label: "Activated"
            },
            {
                value: deactivated,
                color: "#46BFBD",
                highlight: "#5AD3D1",
                label: "De-activated"
            }
        ]}
        charts.push(chart);

        chart = {name : 'Not Receiving Data', type: 'pie', data: [{
            value: notReceivingData,
            color: "#FDB45C",
            highlight: "#5AD3D1",
            label: "Active and not receiving data"
            },
            {
                value: total - notReceivingData,
                color: "#46BFBD",
                highlight: "#5AD3D1",
                label: "Active and receiving data"
            }
        ]}
        charts.push(chart);

        chart = {
            name : 'Hearing Tests Completed Today', 
            type: 'text', 
            value: (this.props.reports === undefined || this.props.reports === null) ? 0 : Object.keys(this.props.reports).length,            
        }
        charts.push(chart);

        this.setState({ 'charts' : charts });
    }



    render() {
        return (<main>
                <div className="container">
                    <div className="graphs">
                        <div className="row">
                            {
                                this.state.charts.map(chart => {
                                    if (chart.type === 'pie') {
                                        return (
                                            <div className="col-sm-4" key={chart.name}>
                                                <div className="card graph-card">
                                                    <PieChart options={options} data={chart.data} />
                                                    <div className="chart-header">{chart.name}</div>
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className="col-sm-4" key={chart.name}>
                                                <div className="card graph-card">
                                                    <h1><b>{chart.value}</b></h1>
                                                    <div className="chart-header">{chart.name}</div>
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </main>)
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, pharmacies } = state.pharmaciesReducer;
    const { reports } = state.reportsReducer;
    return { fetching, fetched, failed, pharmacies, reports };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ fetchPharmacies, fetchReports }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePage));


// EXPORT COMPONENT

export { hoc as HomePage };